import React from 'react';
import { CheckCircle2Icon, FileSignatureIcon, GlobeIcon, MegaphoneIcon, MessageCircleIcon, PhoneMissedIcon, SendIcon, StarIcon, TargetIcon } from 'lucide-react';
import type { JourneyStage } from '../../data/crm';
type JourneyIllustrationProps = {
  stage: JourneyStage['id'];
};
const card = 'rounded-xl border border-gray-200 bg-white p-4 shadow-sm';
export function JourneyIllustration({
  stage
}: JourneyIllustrationProps) {
  return <div className="flex h-full min-h-[320px] flex-col justify-center gap-3 rounded-2xl bg-brand-light p-6" aria-hidden="true" data-id="element-130" data-mp="iuy6zgtbgi36">
      {stage === 'capture' && <>
          {[{
        icon: PhoneMissedIcon,
        label: 'Missed call',
        detail: 'Text-back sent in 5 sec'
      }, {
        icon: GlobeIcon,
        label: 'Website form',
        detail: 'Quote request — water heater'
      }, {
        icon: MessageCircleIcon,
        label: 'Instagram DM',
        detail: '“Do you have openings Sat?”'
      }, {
        icon: TargetIcon,
        label: 'Google ad lead',
        detail: 'Added to pipeline'
      }].map(item => <div key={item.label} className={`${card} flex items-center gap-3`} data-id="element-131" data-mp="2c932hqy6md0q">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-tint text-brand-red" data-id="element-132" data-mp="2866nea7uoz1j">
                <item.icon className="h-4 w-4" data-id="element-133" data-mp="23cbv4ie6jbqu" />
              </span>
              <span className="flex-1" data-id="element-134" data-mp="1yf29ldtwvk8a">
                <span className="block text-xs font-bold text-brand-black" data-id="element-135" data-mp="1tgh7f8v3mqh7">{item.label}</span>
                <span className="block text-xs text-brand-gray" data-id="element-136" data-mp="1te4j8dyqzjvp">{item.detail}</span>
              </span>
              <span className="rounded bg-brand-red px-2 py-0.5 text-[10px] font-bold text-white" data-id="element-137" data-mp="1kfsu6gdj4u5d">New</span>
            </div>)}
        </>}

      {stage === 'nurture' && <div className={`${card} space-y-3`} data-id="element-138" data-mp="1fj2dprxtbwjf">
          <p className="text-xs font-bold text-brand-black" data-id="element-139" data-mp="3essf8p0oigk1">Automated follow-up</p>
          <p className="max-w-[80%] rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-140" data-mp="39u7feqpc9yw4">
            Hi Maria! Thanks for reaching out about a cleaning. Want to grab a time this week?
          </p>
          <p className="text-[10px] text-brand-gray" data-id="element-141" data-mp="1lpw3fduor6t">Sent instantly · Day 1</p>
          <p className="ml-auto max-w-[70%] rounded-2xl rounded-br-md bg-brand-red px-3 py-2 text-xs text-white" data-id="element-142" data-mp="3jz78inhixg7m">
            Yes! Thursday afternoon?
          </p>
          <p className="max-w-[80%] rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-143" data-mp="3ove5vrvutjdy">
            You’re booked for Thu at 3:00 PM. We’ll send a reminder the day before.
          </p>
          <div className="flex items-center gap-2 border-t border-gray-100 pt-3 text-xs font-semibold text-brand-black" data-id="element-144" data-mp="6jrh45uu70kx">
            <CheckCircle2Icon className="h-4 w-4 text-brand-red" data-id="element-145" data-mp="bi2rchp1nd3o" /> Appointment booked by AI
          </div>
        </div>}

      {stage === 'close' && <>
          <div className={card} data-id="element-146" data-mp="2w939yuj706nh">
            <div className="flex items-center justify-between" data-id="element-147" data-mp="2w9cx8acurzph">
              <span className="flex items-center gap-2 text-xs font-bold text-brand-black" data-id="element-148" data-mp="2opk54y6vh8lc">
                <FileSignatureIcon className="h-4 w-4 text-brand-red" data-id="element-149" data-mp="2orequepyx4qh" /> Estimate #1042
              </span>
              <span className="rounded bg-brand-light px-2 py-0.5 text-[10px] font-semibold text-brand-black" data-id="element-150" data-mp="2xq9x1qt0iets">Signed</span>
            </div>
            <div className="mt-4 space-y-2 text-xs text-brand-gray" data-id="element-151" data-mp="2ss8ed6zi0hiu">
              <div className="flex justify-between" data-id="element-152" data-mp="251bdcp98r4md"><span data-id="element-153" data-mp="252e6z4xy7l5z">Roof repair — labor</span><span data-id="element-154" data-mp="24zi3z278u6ao">$1,800</span></div>
              <div className="flex justify-between" data-id="element-155" data-mp="210j3btsjovp1"><span data-id="element-156" data-mp="211kj2bkia6d3">Materials</span><span data-id="element-157" data-mp="20xwqbemvxnzf">$650</span></div>
              <div className="flex justify-between border-t border-gray-100 pt-2 font-bold text-brand-black" data-id="element-158" data-mp="2erxref1b7n2y"><span data-id="element-159" data-mp="2a05xbuiy2z82">Total</span><span data-id="element-160" data-mp="29zmpx7qx7t8a">$2,450</span></div>
            </div>
          </div>
          <div className={`${card} flex items-center gap-3`} data-id="element-161" data-mp="1matpaxzcsx7c">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-red text-white" data-id="element-162" data-mp="1m9abde166y8q">
              <CheckCircle2Icon className="h-4 w-4" data-id="element-163" data-mp="1h9xmyounhj41" />
            </span>
            <span data-id="element-164" data-mp="1v0ag0glcyuv2">
              <span className="block text-xs font-bold text-brand-black" data-id="element-165" data-mp="1uwmlbe46g2er">Deposit paid by text</span>
              <span className="block text-xs text-brand-gray" data-id="element-166" data-mp="1zvpsb43pwipd">Job locked in for Monday</span>
            </span>
          </div>
        </>}

      {stage === 'evangelize' && <>
          <div className={card} data-id="element-167" data-mp="29oy8uf3tkqhb">
            <div className="flex gap-0.5 text-brand-red" data-id="element-168" data-mp="2dph1uchg82l3">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-169" data-mp="2io1unqudfjzi" />)}
            </div>
            <p className="mt-2 text-xs leading-relaxed text-brand-black" data-id="element-170" data-mp="2nmv6zfxx94y3">“Showed up on time, fixed it fast, and the price was exactly what they quoted.”</p>
            <div className="mt-3 rounded-lg bg-brand-light p-3 text-xs text-brand-gray" data-id="element-171" data-mp="2slpwf0qe9rr6">
              <span className="font-bold text-brand-black" data-id="element-172" data-mp="taydzijtzr0x">Your reply:</span> Thank you so much! We’re glad we could help — see you next season.
            </div>
          </div>
          <div className={`${card} flex items-center gap-3`} data-id="element-173" data-mp="3bjrqncc4mo3v">
            <SendIcon className="h-4 w-4 text-brand-red" data-id="element-174" data-mp="36s9rmttnyxlj" />
            <span className="text-xs font-semibold text-brand-black" data-id="element-175" data-mp="36qqal106oiip">Shared to your Facebook & Instagram</span>
          </div>
        </>}

      {stage === 'reactivate' && <div className={card} data-id="element-176" data-mp="2xsmnw1dgpfpb">
          <div className="flex items-center gap-2" data-id="element-177" data-mp="2xp8n2xkg5ejz">
            <MegaphoneIcon className="h-4 w-4 text-brand-red" data-id="element-178" data-mp="3uhvmx66x0so9" />
            <p className="text-xs font-bold text-brand-black" data-id="element-179" data-mp="3qg0oc9gdcte6">Spring Tune-Up Campaign</p>
          </div>
          <div className="mt-4 space-y-2 text-xs" data-id="element-180" data-mp="3lgxm0wrrx19w">
            <div className="flex justify-between rounded-md bg-brand-light px-3 py-2" data-id="element-181" data-mp="3lfcnkw2c8y6r">
              <span className="text-brand-gray" data-id="element-182" data-mp="3gh1e4mfygpp2">Audience</span>
              <span className="font-semibold text-brand-black" data-id="element-183" data-mp="2a1hbjw6qd5jr">Last visit 6+ months ago</span>
            </div>
            <div className="flex justify-between rounded-md bg-brand-light px-3 py-2" data-id="element-184" data-mp="2524nj844hsfl">
              <span className="text-brand-gray" data-id="element-185" data-mp="26k31x30ibc6d">Channels</span>
              <span className="font-semibold text-brand-black" data-id="element-186" data-mp="26hqkcqynv3tu">Text + Email</span>
            </div>
          </div>
          <p className="mt-4 rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-187" data-mp="2bgjy8khv0wuj">
            It’s been a while! Book your spring tune-up this month and get 15% off.
          </p>
          <p className="mt-3 flex items-center gap-2 text-xs font-semibold text-brand-black" data-id="element-188" data-mp="1ntbuw83zrxv5">
            <CheckCircle2Icon className="h-4 w-4 text-brand-red" data-id="element-189" data-mp="1nrikqiu66vie" /> Scheduled for Monday, 9:00 AM
          </p>
        </div>}
    </div>;
}